
@if(file) {
  <div
    class="uploaded-files-list"
    [class.uploaded-files-list-readonly]="disabled"
    data-testid="selected-document-preview-tile"
    [attr.data-file-type]="file.type"
    [attr.data-file-name]="file.filename"
    [attr.data-openable]="hasTileAction(file)"
    [attr.data-readonly]="disabled"
    [attr.role]="hasTileAction(file) ? 'link' : null"
    [attr.tabindex]="hasTileAction(file) ? '0' : null"
    [attr.aria-label]="hasTileAction(file) ? 'Open ' + file.filename : null"
    (click)="onTileClick(file)"
    (keydown)="onTileKeydown($event, file)"
  >
    @if(file.type !== 'file') {
      @if (file.type === 'image') {
        <img 
          [ngSrc]="(file.preview !== null && file.preview !== '') ? file.preview! : file.path" 
          [disableOptimizedSrcset]="(file.path).endsWith('.gif')"
          [width]="150" 
          [height]="100" 
          [sizes]="'100vw, 100vw, 100vw'" 
          [alt]="file.filename" 
          priority="low" 
          class="upload-image" appNgSrcImageError />
      } @else {
        @if (file.preview) {
          <img
            [ngSrc]="file.preview"
            [width]="150"
            [height]="100"
            [sizes]="'100vw, 100vw, 100vw'"
            [alt]="file.filename"
            priority="low"
            class="upload-image" appNgSrcImageError />
        }
        <div class="image-preview-overlay" (click)="onTileClick(file); $event.stopPropagation()"></div>
      }
    } @else if (file.type === 'file') {
      <div class="fileIcons" data-testid="selected-document-preview-file-body" (click)="onTileClick(file); $event.stopPropagation()">
        <div class="file-icon-container" [class]="documentService.getDocumentClass(file)">
          <span class="fileIconBase mts-icon mts-icon-filled notranslate fs-l lh-base" translate="no">insert_drive_file</span>
          <div class="file-type">{{ documentService.getDocumentExtension(file) }}</div>
        </div>
      </div>
    }
    <div class="position-absolute top-0 start-0 ms-1 mt-1 icon-background icons" data-testid="selected-document-preview-info" (click)="$event.stopPropagation()">
      <app-tooltip [type]="'File'" [opensOn]="'Auto'" [file]="file" [icon]="'info'" [cssClass]="'p-2'"></app-tooltip>
    </div>

    @if(file.type === 'image' || file.type === 'video') {
      <div class="position-absolute top-0 end-0 me-1 me-sm-1 mt-1 icon-background icons" data-testid="selected-document-preview-gallery" (click)="openGallery($event, file)">
        <app-icon-badge [style]="'default'" [fontSize]="'fs-5'" [fontColor]="'text-white'" [icon]="'visibility'"></app-icon-badge>
      </div>
    } @else {
      <div class="position-absolute top-0 end-0 me-1 me-sm-1 mt-1 icon-background icons" data-testid="selected-document-preview-download" (click)="downloadDocumentFromAction($event, file)">
        <app-icon-badge [style]="'default'" [fontSize]="'fs-5'" [fontColor]="'text-white'" [icon]="'file_download'"></app-icon-badge>
      </div>
    }

    @if (!disabled) {
      <div class="overlay d-flex align-items-center" data-testid="selected-document-preview-overlay" (click)="$event.stopPropagation()">
        @if(position > 0) {
          <div class="left-arrow" data-testid="selected-document-preview-move-left" (click)="$event.stopPropagation(); moveFile(file, 'up')">
            <app-icon-badge [style]="'default'" [icon]="'chevron_left'" [fontColor]="'text-white'">
            </app-icon-badge>
          </div>
        }
        <div class="trash-icon" data-testid="selected-document-preview-remove" (click)="$event.stopPropagation(); showDeleteOverlay(file)">
          <app-icon-badge [style]="'default'" [icon]="removeBadge === 'trash' ? 'delete' : 'cancel'" [fontColor]="'text-white'">
          </app-icon-badge>
        </div>
        @if (position < files.length - 1) {
          <div class="right-arrow" data-testid="selected-document-preview-move-right" (click)="$event.stopPropagation(); moveFile(file, 'down')">
            <app-icon-badge [style]="'default'" [icon]="'chevron_right'" [fontColor]="'text-white'">
            </app-icon-badge>
          </div>
        }
      </div>
    }
  </div>
}
